import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import * as bie from "react-bootstrap";
import Swal from 'sweetalert2';
import { failureAlert, successAlert2, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, AllowFloats, handlePaste } from '../../CommonUtils/CommonValidations';
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { useDispatch, useSelector } from 'react-redux';
import { getDistricts, getMandals, getVillages } from '../../Reducers/AffiliationCommonservice';
import * as Yup from 'yup';
import { VscDiffAdded, VscDiffRemoved } from 'react-icons/vsc';
import { BiTrash } from 'react-icons/bi';
import { viewImage } from '../../CommonUtils/viewImage';
import moment from 'moment';
import { FaRegTrashAlt } from 'react-icons/fa';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { BsEyeFill } from 'react-icons/bs';

export default function AfiliationSocLandAllocation() {
    const userId = sessionStorage.getItem('user_id')
    const acYear = sessionStorage.getItem('ac_year')
    const reducerDistricts = useSelector((state) => state?.commonMastersReducer?.DistList);
    const reducermandal = useSelector((state) => state?.commonMastersReducer?.mandalList);
    const reducervillage = useSelector((state) => state?.commonMastersReducer?.villageList);
    const dispatch = useDispatch();
    const requiredWhenBuildOwnLeaseTrue = Yup.string().when('buildOwnLease', {
        is: 'true',
        then: Yup.string().required(ERROR_MSG).nullable(),
        otherwise: Yup.string().nullable(),
    });
    const requiredWhenBuildOwnLeaseFalse = Yup.string().when('buildOwnLease', {
        is: 'false',
        then: Yup.string().required(ERROR_MSG).nullable(),
        otherwise: Yup.string().nullable(),
    });
    const LandUasgeYes = Yup.string().when('landUsagedata', {
        is: 'true',
        then: Yup.string().required(ERROR_MSG).nullable(),
        otherwise: Yup.string().nullable(),
    });
    const LandConvertionYes = Yup.string().when('landConvData', {
        is: 'true',
        then: Yup.string().required(ERROR_MSG).nullable(),
        otherwise: Yup.string().nullable(),
    });

    const validationSchema = Yup.object({
        buildOwnLease: Yup.string().required(ERROR_MSG).nullable(),
        collegeStrength: Yup.string().required(ERROR_MSG).nullable(),
        samePrimises: Yup.string().required(ERROR_MSG).nullable(),
        society: Yup.string().required(ERROR_MSG).nullable(),
        socOtherCollCode: Yup.array().when('samePrimises', {
            is: 'true',
            then: Yup.array().of(
                Yup.object().shape({
                    otherCollCode: Yup.string().required('Other college Name required'),
                })
            ),
            otherwise: Yup.array().nullable(),
        }),
        noYears: requiredWhenBuildOwnLeaseFalse,
        // leaseDeedHidden: Yup.string().when(['leaseDeed', 'buildOwnLease'], {
        //     is: (leaseDeed, buildOwnLease) => !leaseDeed && (buildOwnLease === false || buildOwnLease == "false"),
        //     then: Yup.string().required(ERROR_MSG).nullable(),
        //     otherwise: Yup.string().nullable(),
        // }),

        leaseDeed: Yup.string().when('buildOwnLease', {
            is: 'false',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        landAlloc: requiredWhenBuildOwnLeaseTrue,
        regType: requiredWhenBuildOwnLeaseTrue,
        landType: requiredWhenBuildOwnLeaseTrue,
        allocDate: requiredWhenBuildOwnLeaseTrue,
        allocUpto: requiredWhenBuildOwnLeaseTrue,
        socUpload: requiredWhenBuildOwnLeaseTrue,

        khasraIssuedBy: requiredWhenBuildOwnLeaseTrue,
        khasraDate: requiredWhenBuildOwnLeaseTrue,
        khasraDocNo: requiredWhenBuildOwnLeaseTrue,
        khasraPlan: requiredWhenBuildOwnLeaseTrue,

        landConvData: requiredWhenBuildOwnLeaseTrue,
        landUsagedata: requiredWhenBuildOwnLeaseTrue,
        landIssued: LandConvertionYes,
        landDate: LandConvertionYes,
        landPurpose: LandConvertionYes,
        landFile: LandConvertionYes,

        landUsage: LandUasgeYes,
        landUsageDate: LandUasgeYes,
        landUsagePurpose: LandUasgeYes,
        landUsageCerti: LandUasgeYes,

        landCollRun: requiredWhenBuildOwnLeaseTrue,
        platNo: requiredWhenBuildOwnLeaseFalse,
        surveyNo: requiredWhenBuildOwnLeaseFalse,
        distance: requiredWhenBuildOwnLeaseFalse,
        distCode: requiredWhenBuildOwnLeaseFalse,
        mandalCode: requiredWhenBuildOwnLeaseFalse,
        villageCode: requiredWhenBuildOwnLeaseFalse,
        totalLand: requiredWhenBuildOwnLeaseFalse,
        // socLand: Yup.array().when('buildOwnLease', {
        //     is: (val) => val === "true" || val === "false" || val == true || val === false,
        //     then: Yup.array().of(
        //         Yup.object().shape({
        //             regNo: Yup.string().matches(/^\d{4}\/\d{4}$/, 'Registration number must be in the format 0001/9898').required(ERROR_MSG).nullable(),
        //             regDate: Yup.string().required(ERROR_MSG).nullable(),
        //             surveyNo: Yup.string().required(ERROR_MSG).nullable(),
        //             areaAcres: Yup.string().required(ERROR_MSG).nullable(),
        //             district: Yup.string().required(ERROR_MSG).nullable(),
        //             sroDiv: Yup.string().required(ERROR_MSG).nullable(),
        //             sroOffice: Yup.string().required(ERROR_MSG).nullable(),
        //             uploadRegDoc: Yup.string().required(ERROR_MSG).nullable(),
        //             landEcDoc: Yup.string().required(ERROR_MSG).nullable(),
        //             isLandMortgaged: Yup.string().required(ERROR_MSG).nullable(),

        //             mortgageRegisteredDocNo: Yup.string()
        //                 .nullable()
        //                 .when('isLandMortgaged', {
        //                     is: 'true',
        //                     then: Yup.string().required(ERROR_MSG).nullable(),
        //                     otherwise: Yup.string().nullable(),
        //                 }),
        //         })
        //     ),
        //     otherwise: Yup.array().nullable(),
        // }),


        // socBuildingLease: Yup.array().when('buildOwnLease', {
        //     is: 'false',
        //     then: Yup.array().of(
        //         Yup.object().shape({
        //             documentNumber: Yup.string().matches(/^\d{4}\/\d{4}$/, 'Document number must be in the format 0001/9898').required(ERROR_MSG).nullable(),
        //             dateOfRegistration: Yup.string().required(ERROR_MSG).nullable(),
        //             surveyNumber: Yup.string().required(ERROR_MSG).nullable(),
        //             distId: Yup.string().required(ERROR_MSG).nullable(),
        //             sroDiv: Yup.string().required(ERROR_MSG).nullable(),
        //             sroOffice: Yup.string().required(ERROR_MSG).nullable(),
        //             nameOfLeasee: Yup.string().required(ERROR_MSG).nullable(),
        //             leasedFrom: Yup.string().required(ERROR_MSG).nullable(),
        //             leasedUpto: Yup.string().required(ERROR_MSG).nullable(),
        //             address: Yup.string().required(ERROR_MSG).nullable(),
        //             extentOfLand: Yup.string().required(ERROR_MSG).nullable(),
        //         })
        //     ),
        //     otherwise: Yup.array().nullable(),
        // }),
    });
    const soclandalloFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            society: "",
            collCode: userId,
            acYear: acYear,
            buildOwnLease: "",
            noYears: "",
            leaseDeed: "",
            collegeStrength: "",
            samePrimises: "",
            landCollRun: "",
            landAlloc: "",
            regType: "",
            landType: "",
            allocDate: "",
            allocUpto: "",
            socUpload: "",
            khasraIssuedBy: "",
            khasraDate: "",
            khasraDocNo: "",
            khasraPlan: "",
            landConvData: "",
            landUsagedata: "",
            landIssued: "",
            landDate: "",
            landPurpose: "",
            landFile: "",
            landUsage: "",
            landUsageDate: "",
            landUsagePurpose: "",
            landUsageCerti: "",
            platNo: "",
            surveyNo: "",
            distance: "",
            distCode: "",
            mandalCode: "",
            villageCode: "",
            totalLand: "",
            socOtherCollCode: [{
                otherCollCode: ''
            }],
            socBuildingLease: [
                {
                    documentNumber: "",
                    dateOfRegistration: "",
                    surveyNumber: "",
                    distId: "",
                    sroDiv: "",
                    sroOffice: "",
                    nameOfLeasee: "",
                    leasedFrom: "",
                    leasedUpto: "",
                    address: "",
                    extentOfLand: ""
                }
            ],
            socLand: [
                {
                    regNo: "",
                    regDate: "",
                    surveyNo: "",
                    areaAcres: "",
                    district: "",
                    village: 0,
                    mandal: 0,
                    sroDiv: "",
                    sroOffice: "",
                    uploadRegDoc: "",
                    landEcDoc: "",
                    isLandMortgaged: "",
                    mortgageRegisteredDocNo: "",
                }
            ],
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const convertValues = (data) => ({
                ...data,
                areaAcres: data.areaAcres || '',
                district: parseInt(data.district, 10) || 0,
                sroDiv: parseInt(data.sroDiv, 10) || '',
                sroOffice: parseInt(data.sroOffice, 10) || '',
                village: 0,
                mandal: 0,

            });
            // values?.socBuildingLease = values?.socBuildingLease[0]?.address === '' ? [] : values?.socBuildingLease;
            if (Array.isArray(values.socBuildingLease)) {
                const hasFirstAddress =
                    typeof values.socBuildingLease[0]?.documentNumber === 'string' &&
                    values.socBuildingLease[0].documentNumber.trim() !== '';

                if (!hasFirstAddress) {
                    values.socBuildingLease = [];
                }
                // else, leave it untouched
            }
            if (Array.isArray(values.socLand)) {
                const Socland =
                    typeof values.socLand[0]?.regNo === 'string' &&
                    values.socLand[0].regNo.trim() !== '';

                if (!Socland) {
                    values.socLand = [];
                }
                // else, leave it untouched
            }

            const payload = {
                collCode: parseInt(values.collCode, 10) || '',
                acYear: values.acYear,
                buildOwnLease: values.buildOwnLease,
                collegeStrength: parseInt(values.collegeStrength, 10) || '',
                samePrimises: values.samePrimises,
                noYears: parseInt(values.noYears, 10) || '',
                platNo: parseInt(values.platNo, 10) || '',
                surveyNo: values.surveyNo,
                distance: values.distance || '',
                distCode: parseInt(values.distCode, 10) || 0,
                mandalCode: parseInt(values.mandalCode, 10) || 0,
                villageCode: parseInt(values.villageCode, 10) || 0,
                totalLand: values.totalLand || '',
                leaseDeed: values.leaseDeed,
                landAlloc: values.landAlloc || '',
                landCollRun: values.landCollRun || '',
                regType: parseInt(values.regType, 10) || '',
                landType: parseInt(values.landType, 10) || '',
                allocDate: values.allocDate,
                allocUpto: values.allocUpto,
                socUpload: values.socUpload,
                khasraIssuedBy: values.khasraIssuedBy,
                khasraDate: values.khasraDate,
                khasraDocNo: values.khasraDocNo,
                khasraPlan: values.khasraPlan,
                landUsageDate: values.landUsageDate,
                landUsagedata: values.landUsagedata,
                landUsagePurpose: values.landUsagePurpose,
                landUsageCerti: values.landUsageCerti,
                landFile: values.landFile,
                society: values?.society,
                landIssued: values.landIssued,
                landDate: values.landDate,
                landUsage: values.landUsage,
                landPurpose: values.landPurpose,
                landConvData: values?.landConvData,
                socOtherCollCode: values.socOtherCollCode.map(vall => ({
                    otherCollCode: parseInt(vall.otherCollCode, 10) || 0,
                })),
                socBuildingLease: values.socBuildingLease.map(lease => ({
                    documentNumber: lease.documentNumber,
                    dateOfRegistration: lease.dateOfRegistration,
                    surveyNumber: lease.surveyNumber,
                    distId: parseInt(lease.distId, 10) || 0,
                    sroDiv: parseInt(lease.sroDiv, 10) || '',
                    sroOffice: parseInt(lease.sroOffice, 10) || '',
                    nameOfLeasee: lease.nameOfLeasee,
                    leasedFrom: lease.leasedFrom,
                    leasedUpto: lease.leasedUpto,
                    address: lease.address,
                    extentOfLand: lease.extentOfLand || '',
                })),
                socLand: values.socLand.map(land => convertValues(land)),
            };

            // // 🔍 Check for duplicates in either doc num or survey num — but display only what matches
            // for (let i = 0; i < payload.socBuildingLease.length; i++) {
            //     const newLease = payload.socBuildingLease[i];
            //     const serialNo = i + 1;

            //     const matched = LeaseDetails.find(existing =>
            //         existing.document_number === newLease.documentNumber ||
            //         existing.survey_number === newLease.surveyNumber
            //     );

            //     if (matched) {
            //         const duplicateFields = [];

            //         if (matched.document_number === newLease.documentNumber) {
            //             duplicateFields.push(`Reg. No: <strong>${newLease.documentNumber}</strong>`);
            //         }

            //         if (matched.survey_number === newLease.surveyNumber) {
            //             duplicateFields.push(`Survey No: <strong>${newLease.surveyNumber}</strong>`);
            //         }

            //         // ⚠️ Only show alert if at least one field is truly duplicate
            //         if (duplicateFields.length > 0) {
            //             const message = `
            //     At Serial No ${serialNo}: Duplicate found —<br>
            //     ${duplicateFields.join(', ')}`;

            //             Swal.fire({
            //                 icon: 'error',
            //                 title: 'Duplicate Entry Detected',
            //                 html: message,
            //                 backdrop: false,
            //             });

            //             return;
            //         }
            //     }
            // }

            // // //cheching duplicate own details 

            // for (let i = 0; i < payload.socLand?.length; i++) {
            //     const newLease = payload.socLand[i];
            //     const serialNo = i + 1;

            //     const matched = OwnDetails.find(existing =>
            //         existing.reg_no === newLease.regNo ||
            //         existing.survey_no === newLease.surveyNo
            //     );

            //     if (matched) {
            //         const duplicateFields = [];

            //         if (matched.reg_no === newLease.regNo) {
            //             duplicateFields.push(`Reg. No: <strong>${newLease.regNo}</strong>`);
            //         }

            //         if (matched.survey_no === newLease.surveyNo) {
            //             duplicateFields.push(`Survey No: <strong>${newLease.surveyNo}</strong>`);
            //         }

            //         // ⚠️ Only show alert if at least one field is truly duplicate
            //         if (duplicateFields.length > 0) {
            //             const message = `
            //     At Serial No ${serialNo}: Duplicate found —<br>
            //     ${duplicateFields.join(', ')}`;

            //             Swal.fire({
            //                 icon: 'error',
            //                 title: 'Duplicate Land Details',
            //                 html: message,
            //                 backdrop: false,
            //             });

            //             return;
            //         }
            //     }
            // }

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveSocietyLandDetails`;
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlertRefresh(res?.data?.sdesc);
                            // GetLeaseData(); GetOwnData(); GetLandData();
                            socBuildingLease: values.socBuildingLease.map(lease => ({
                                documentNumber: lease.documentNumber,
                                dateOfRegistration: lease.dateOfRegistration,
                                surveyNumber: lease.surveyNumber,
                                distId: parseInt(lease.distId, 10) || 0,
                                sroDiv: parseInt(lease.sroDiv, 10) || '',
                                sroOffice: parseInt(lease.sroOffice, 10) || '',
                                nameOfLeasee: lease.nameOfLeasee,
                                leasedFrom: lease.leasedFrom,
                                leasedUpto: lease.leasedUpto,
                                address: lease.address,
                                extentOfLand: parseInt(lease.extentOfLand, 10) || '',
                            }));
                            socLand: values.socLand.map(land => convertValues(land))
                        }
                    });
                }
            })
        },
    })
    function ClearSamePremises() {
        soclandalloFormik.setFieldValue("socOtherCollCode", [{}]);
    }
    function ClearLandConversion() {
        soclandalloFormik.setFieldValue("landConvData", "");
        soclandalloFormik.setFieldValue("landIssued", "");
        soclandalloFormik.setFieldValue("landDate", "");
        soclandalloFormik.setFieldValue("landPurpose", "");
        soclandalloFormik.setFieldValue("landFile", "");
    }
    function ClearLandUsage() {
        soclandalloFormik.setFieldValue("landUsage", "");
        soclandalloFormik.setFieldValue("landUsagePurpose", "");
        soclandalloFormik.setFieldValue("landUsageCerti", "");
        soclandalloFormik.setFieldValue("landUsagedata", "");
        soclandalloFormik.setFieldValue("landUsageDate", "");
    }
    function ClearLeaseDetails() {
        soclandalloFormik.setFieldValue("noYears", "");
        soclandalloFormik.setFieldValue("leaseDeed", "");
        soclandalloFormik.setFieldValue("landCollRun", "");
        soclandalloFormik.setFieldValue("platNo", "");
        soclandalloFormik.setFieldValue("surveyNo", "");
        soclandalloFormik.setFieldValue("distance", "");
        soclandalloFormik.setFieldValue("distCode", "");
        soclandalloFormik.setFieldValue("mandalCode", "");
        soclandalloFormik.setFieldValue("villageCode", "");
        soclandalloFormik.setFieldValue("socBuildingLease", [{
            documentNumber: "",
            dateOfRegistration: "",
            surveyNumber: "",
            distId: "",
            sroDiv: "",
            sroOffice: "",
            nameOfLeasee: "",
            leasedFrom: "",
            leasedUpto: "",
            address: "",
            extentOfLand: ""
        }]);
    }
    function clearMandalsFunc() {
        soclandalloFormik.setFieldValue("mandalCode", "");
        dispatch({ type: "MANDALS_LIST", payload: [] });
    }
    function clearVillagesFunc() {
        soclandalloFormik.setFieldValue("villageCode", "");
        dispatch({ type: "VILLAGES_LIST", payload: [] });
    }
    function ClearOwnDetails() {
        soclandalloFormik.setFieldValue("landAlloc", "");
        soclandalloFormik.setFieldValue("regType", "");
        soclandalloFormik.setFieldValue("landType", "");
        soclandalloFormik.setFieldValue("allocDate", "");
        soclandalloFormik.setFieldValue("allocUpto", "");
        soclandalloFormik.setFieldValue("socUpload", "");
        soclandalloFormik.setFieldValue("khasraIssuedBy", "");
        soclandalloFormik.setFieldValue("khasraDate", "");
        soclandalloFormik.setFieldValue("khasraDocNo", "");
        soclandalloFormik.setFieldValue("khasraPlan", "");
        soclandalloFormik.setFieldValue("landConvData", "");
        soclandalloFormik.setFieldValue("landUsagedata", "");
        soclandalloFormik.setFieldValue("landIssued", "");
        soclandalloFormik.setFieldValue("landDate", "");
        soclandalloFormik.setFieldValue("landFile", "");
        soclandalloFormik.setFieldValue("landUsage", "");
        soclandalloFormik.setFieldValue("landUsagePurpose", "");
        soclandalloFormik.setFieldValue("landUsageCerti", "");
        ClearLandConversion();
        ClearLandUsage();
    }

    const [collegeList, setcollegelist] = useState([]);
    function GetCollegesList() {
        let url = config.url.API_URL + `getCollList`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setcollegelist(res?.data?.collList)
            } else {
                setcollegelist([])
            }
        })
    }
    const [prosroDist, setprosroDist] = useState([]);
    function GetProSroDist(distcode, index) {
        if (!distcode) {
            return;
        }
        let url = config.url.API_URL + `getsroDist/` + distcode
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setprosroDist(prevState => {
                    const updatedList = [...prevState];
                    updatedList[index] = res?.data?.getsroDist;
                    return updatedList;
                });
            } else {
                setprosroDist(prevState2 => {
                    const updatedList = [...prevState2];
                    updatedList[index] = [];
                    return updatedList;
                });
            }
        })
    }
    const [SroDist, setSroDist] = useState([]);
    function GetSroDist(distcode, index) {
        let url = config.url.API_URL + `getsroDist/` + distcode
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setSroDist(prevState3 => {
                    const updatedList = [...prevState3];
                    updatedList[index] = res?.data?.getsroDist;
                    return updatedList;
                });
                setprosroDist(prevState4 => {
                    const updatedList = [...prevState4];
                    updatedList[index] = res?.data?.getsroDist;
                    return updatedList;
                });
            } else {
                setSroDist(prevState5 => {
                    const updatedList = [...prevState5];
                    updatedList[index] = [];
                    return updatedList;
                });
            }
        })
    }
    const [RegOfffices, setRegOffices] = useState([]);
    function GetRegOfffices(distcode, srodivcode, index) {
        let url = config.url.API_URL + `getRegOffice/` + distcode + "/" + srodivcode
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setRegOffices(prevState6 => {
                    const updatedList = [...prevState6];
                    updatedList[index] = res?.data?.getRegOffice;
                    return updatedList;
                });
            } else {
                setRegOffices(prevState7 => {
                    const updatedList = [...prevState7];
                    updatedList[index] = [];
                    return updatedList;
                });
            }
        })
    }
    const [proRegOfffices, setproRegOffices] = useState([]);
    function GetProRegOfffices(distcode, srodivcode, index) {
        if (!distcode && !srodivcode) {
            return
        }
        let url = config.url.API_URL + `getRegOffice/` + distcode + "/" + srodivcode
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setproRegOffices(prevState8 => {
                    const updatedList = [...prevState8];
                    updatedList[index] = res?.data?.getRegOffice;
                    return updatedList;
                });
            } else {
                setproRegOffices(prevState9 => {
                    const updatedList = [...prevState9];
                    updatedList[index] = [];
                    return updatedList;
                });

            }
        })
    }
    const [LeaseDetails, setLeaseDetails] = useState([]);
    function GetLeaseData() {
        let url = config.url.API_URL + `getLeaseDetails`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setLeaseDetails(res?.data?.LeaseDetails)

                // res?.data?.LeaseDetails?.forEach((data, i) => {
                //     const RegDate = data?.date_of_registration && moment(data?.date_of_registration,
                //         'DD/MM/YYYY', true).isValid() ? moment(data?.date_of_registration, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                //     const LeasUpto = data?.leased_upto && moment(data?.leased_upto,
                //         'DD/MM/YYYY', true).isValid() ? moment(data?.leased_upto, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                //     const LeaseFrom = data?.leased_from && moment(data?.leased_from,
                //         'DD/MM/YYYY', true).isValid() ? moment(data?.leased_from, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';

                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].documentNumber`, data?.document_number);
                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].dateOfRegistration`, RegDate);
                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].surveyNumber`, data?.survey_number);
                //     GetSroDist(data?.dist_id, i)
                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].distId`, data?.dist_id)

                //     GetRegOfffices(data?.dist_id, data?.sro_div, i)
                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].sroDiv`, data?.sro_div);

                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].sroOffice`, data?.sro_office);
                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].nameOfLeasee`, data?.name_of_leasee);
                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].leasedFrom`, LeaseFrom);
                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].leasedUpto`, LeasUpto);
                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].address`, data?.address);
                //     soclandalloFormik?.setFieldValue(`socBuildingLease[${i}].extentOfLand`, data?.extent_of_land);


                // })

            } else {
                setLeaseDetails([])
            }
        })
    }

    const [OwnDetails, setOwnDetails] = useState([]);
    function GetOwnData() {
        let url = config.url.API_URL + `getOwnDetails`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setOwnDetails(res?.data?.OwnDetails)




            } else {
                setOwnDetails([])
            }
        })
    }
    function GetOtherCollegeList() {
        let url = config.url.API_URL + `getOtherCollList`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const initialValues = res?.data?.getotherCollList?.map((course) => ({
                    otherCollCode: course?.other_coll_code?.toString() ?? ''

                }));
                soclandalloFormik?.setFieldValue('socOtherCollCode', initialValues);
            }
        });
    }

    const [LandDetails, setLandDetails] = useState([]);
    function GetLandData() {
        let url = config.url.API_URL + `getLandDetails`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setLandDetails(res?.data?.LandDetails[0])
                const khasraDates = res?.data?.LandDetails[0]?.khasra_issued_date ? moment(res?.data?.LandDetails[0]?.khasra_issued_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                const LandUsageIssuedDate = res?.data?.LandDetails[0]?.land_usage_issued_date ? moment(res?.data?.LandDetails[0]?.land_usage_issued_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                const convisuuedate = res?.data?.LandDetails[0]?.land_conversion_issued_date ? moment(res?.data?.LandDetails[0]?.land_conversion_issued_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                const SocAllocateDate = res?.data?.LandDetails[0]?.soc_land_alloc_date ? moment(res?.data?.LandDetails[0]?.soc_land_alloc_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                const SocAllocateUptoDate = res?.data?.LandDetails[0]?.soc_land_alloc_valid_upto ? moment(res?.data?.LandDetails[0]?.soc_land_alloc_valid_upto, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                soclandalloFormik?.setFieldValue("buildOwnLease", res?.data?.LandDetails[0]?.build_own_lease + "")
                soclandalloFormik?.setFieldValue("collegeStrength", res?.data?.LandDetails[0]?.college_strength)
                soclandalloFormik?.setFieldValue("samePrimises", res?.data?.LandDetails[0]?.same_primises?.toString() ?? '')
                soclandalloFormik?.setFieldValue("noYears", res?.data?.LandDetails[0]?.no_years)
                soclandalloFormik?.setFieldValue("landType", res?.data?.LandDetails[0]?.land_type)
                soclandalloFormik?.setFieldValue("regType", res?.data?.LandDetails[0]?.land_reg_type)
                soclandalloFormik?.setFieldValue("allocDate", SocAllocateDate)
                soclandalloFormik?.setFieldValue("allocUpto", SocAllocateUptoDate)
                soclandalloFormik?.setFieldValue("leaseDeed", res?.data?.LandDetails[0]?.lease_deed ?? '')
                soclandalloFormik?.setFieldValue("platNo", res?.data?.LandDetails[0]?.plot_no)
                soclandalloFormik?.setFieldValue("surveyNo", res?.data?.LandDetails[0]?.survey_no)
                soclandalloFormik?.setFieldValue("distance", res?.data?.LandDetails[0]?.distance)
                getDistricts(res?.data?.LandDetails[0]?.dist_code)
                soclandalloFormik?.setFieldValue("distCode", res?.data?.LandDetails[0]?.dist_code ?? '', dispatch)
                getMandals(res?.data?.LandDetails[0]?.dist_code, dispatch);
                soclandalloFormik?.setFieldValue("mandalCode", res?.data?.LandDetails[0]?.mandal_code ?? '')
                getVillages(res?.data?.LandDetails[0]?.dist_code, res?.data?.LandDetails[0]?.mandal_code ?? '', dispatch)
                soclandalloFormik?.setFieldValue("villageCode", res?.data?.LandDetails[0]?.village_code ?? '')
                soclandalloFormik?.setFieldValue("totalLand", res?.data?.LandDetails[0]?.total_land)
                soclandalloFormik?.setFieldValue("landCollRun", res?.data?.LandDetails[0]?.total_land)
                soclandalloFormik?.setFieldValue("landConvData", res?.data?.LandDetails[0]?.land_conv_details?.toString() ?? '')
                soclandalloFormik?.setFieldValue("landAlloc", res?.data?.LandDetails[0]?.land_alloc)
                soclandalloFormik?.setFieldValue("landPurpose", res?.data?.LandDetails[0]?.land_conversion_issued_purpose)
                soclandalloFormik?.setFieldValue("landDate", convisuuedate)
                soclandalloFormik?.setFieldValue("khasraIssuedBy", res?.data?.LandDetails[0]?.khasra_issued_by)
                soclandalloFormik?.setFieldValue("khasraDocNo", res?.data?.LandDetails[0]?.khasra_doc_no)
                soclandalloFormik?.setFieldValue("khasraDate", khasraDates)
                soclandalloFormik?.setFieldValue("khasraPlan", res?.data?.LandDetails[0]?.khasra_plan_file)
                soclandalloFormik?.setFieldValue("landIssued", res?.data?.LandDetails[0]?.land_conversion_issued_by)
                soclandalloFormik?.setFieldValue("landUsagedata", res?.data?.LandDetails[0]?.land_usage_details?.toString() ?? '');
                soclandalloFormik?.setFieldValue("landUsage", res?.data?.LandDetails[0]?.land_usage_issued_by)
                soclandalloFormik?.setFieldValue("landUsageDate", LandUsageIssuedDate)
                soclandalloFormik?.setFieldValue("socUpload", res?.data?.LandDetails[0]?.soc_copy_upload)
                soclandalloFormik?.setFieldValue("landFile", res?.data?.LandDetails[0]?.land_conversion_file)
                soclandalloFormik?.setFieldValue("landUsageCerti", res?.data?.LandDetails[0]?.land_usage_certificate)
                soclandalloFormik?.setFieldValue("landUsagePurpose", res?.data?.LandDetails[0]?.land_usage_purpose)
                soclandalloFormik?.setFieldValue("society", res?.data?.LandDetails[0]?.society)



            } else {
                setLandDetails([])
            }
        })
    }
    useEffect(() => {
        if (LandDetails?.length > 0) {
            soclandalloFormik.setFieldValue("buildOwnLease", LandDetails.build_own_lease + "");
        }
    }, [LandDetails, soclandalloFormik])

    useEffect(() => {
        GetCollegesList();
        GetLeaseData(); GetOwnData(); GetLandData();
        getDistricts();
        GetOtherCollegeList();
    }, [])
    const DeleteLeaseDetails = (sno) => {
        const proceedingpayload = {
            collCode: Number(userId),
            acYear: acYear,
            slno: sno,
        };
        Swal.fire({
            title: `Are you sure want to Delete the File?`,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                CommonAxiosPost(config.url.API_URL + "deleteLeaseDetails", proceedingpayload).then((res) => {
                    if (res.data.scode === "01") {
                        successAlert2(res.data.sdesc);
                        GetLeaseData();
                    } else {
                        failureAlert(res.data.sdesc);
                    }
                });
            }
        });
    };
    const DeleleSocLandDetails = (sno) => {
        const proceedingpayload = {
            collCode: Number(userId),
            acYear: acYear,
            slno: sno,
        };
        Swal.fire({
            title: `Are you sure want to Delete the File?`,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                CommonAxiosPost(config.url.API_URL + "deleteSocietyLandDetails", proceedingpayload).then((res) => {
                    if (res.data.scode === "01") {
                        successAlert2("Succesfully Deleted");
                        GetOwnData();
                    } else {
                        failureAlert(res.data.sdesc);
                    }
                });
            }
        });
    };
    const formatRegNoInput = (e, name) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');

        // Limit to 8 digits total
        if (value.length > 8) value = value.slice(0, 8);

        // Insert slash after 4 digits
        if (value.length > 4) {
            value = value.slice(0, 4) + '/' + value.slice(4);
        }

    }
    return (
        <>
            <CommonFormHeading heading="Society Land Allotment Details" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={soclandalloFormik}>
                        <Form onChange={soclandalloFormik.handleChange} onSubmit={soclandalloFormik.handleSubmit} className="affl-form">
                            <bie.Row className="px-2 pt-3 m-0">
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                    <label className='mb-1'>
                                        <b style={{ color: 'red' }}>* </b>
                                        Whether the land is available in the name of society:
                                    </label>
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>

                                    <Field as='select' name="society" className='form-control mb-2'>
                                        <option value="">--Select--</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>

                                    </Field>
                                    <ErrorMessage name="society" component="div" className="text-error" />

                                </bie.Col>
                            </bie.Row>

                            {soclandalloFormik?.values?.society === "Yes" ? (<>

                                <bie.Row className="px-2 pt-3 m-0">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label classname='mb-1' ><b style={{ color: 'red' }}>* </b>Type of College Accomodation:</label>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>

                                        <Field as='select' name="buildOwnLease" className='form-control mb-2' onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === "false" || OwnDetails?.length === 0) {
                                                ClearOwnDetails();
                                            }
                                            else if (value === "true" || LeaseDetails?.length === 0) {
                                                ClearLeaseDetails();
                                            }
                                        }}>
                                            <option value="">--Select--</option>
                                            <option value="false">Leased</option>
                                            <option value="true">Own</option></Field>
                                        <ErrorMessage name="buildOwnLease" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>

                                {soclandalloFormik?.values?.buildOwnLease === "false" ? (<>

                                    <bie.Row className="pt-3 align-items-end py-3">

                                        <bie.Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                                            <label className='mb-1'>
                                                <b style={{ color: 'red' }}>* </b>No. of Years the college is being run in Leased Accommodation:
                                            </label>
                                            <Field
                                                type='text'
                                                name="noYears"
                                                className='form-control'
                                                onKeyPress={(e) => allowNumbersOnly(e)}
                                                onPaste={(e) => handlePaste(e)}
                                                maxLength="2"
                                            />
                                            <ErrorMessage name="noYears" component="div" className="text-error" />
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                                            <label className='mb-1'>
                                                <b style={{ color: 'red' }}>* </b>Upload Building Lease Deed:
                                            </label>
                                            <input
                                                type="file"
                                                accept="application/pdf"
                                                name="leaseDeed"
                                                className="form-control"
                                                onChange={(e) => {
                                                    let filename = `leaseDeed`;
                                                    let path = "/Uploads/AffiliationLandAllotmentDocuments/2023/";
                                                    ImagePdfBucket(e, soclandalloFormik, path, "leaseDeed", filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="leaseDeed" component="div" className="text-error" />
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className="mt-4">
                                            {soclandalloFormik?.values?.leaseDeed && (
                                                <button
                                                    type='button'
                                                    className='btn btn-primary'
                                                    onClick={() => viewImage(soclandalloFormik?.values?.leaseDeed)}
                                                >
                                                    <BsEyeFill size={17} />
                                                </button>
                                            )}
                                        </bie.Col>

                                    </bie.Row>

                                </>) : (<></>)}

                                <div className="inner-herbpage-service-title-sub"  >
                                    <h1 className="mb-0">College Details</h1>
                                </div>
                                <bie.Row className="px-2 my-3 ">
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                        <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>Strength of the college:</label>
                                        <Field type='text' name="collegeStrength" className='form-control down-marg4' maxLength="4" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="collegeStrength" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={5} xxl={4} className='mb-2'>
                                        <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>Is any other College running in the same Premises :</label>
                                        <Field as='select' name="samePrimises" className='form-control '
                                            onChange={(e) => {
                                                if (e?.target?.value === "false") { ClearSamePremises(); }
                                            }}>
                                            <option value="">--Select--</option>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </Field>
                                        <ErrorMessage name="samePrimises" component="div" className="text-error" />

                                    </bie.Col>
                                </bie.Row>

                                {soclandalloFormik?.values?.samePrimises === "true" || soclandalloFormik?.values?.samePrimises === true || LandDetails?.same_primises === "true" ? (<>
                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className="mb-0"> Other College Details</h1>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>SNO</th>
                                                    <th>College Name</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <FieldArray name="socOtherCollCode">
                                                    {({ push, remove }) => (soclandalloFormik?.values?.socOtherCollCode?.map((college, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <center>{index + 1}</center>
                                                            </td>
                                                            <td>
                                                                <Field
                                                                    as="select"
                                                                    name={`socOtherCollCode[${index}].otherCollCode`}
                                                                    className="form-control form-control-md"
                                                                    style={{ width: '48rem' }}
                                                                    onChange={e => {
                                                                        const selectedValue = e.target.value;
                                                                        const isDuplicate = soclandalloFormik?.values?.socOtherCollCode
                                                                            .some((item, idx) => item.otherCollCode === selectedValue && idx !== index);
                                                                        if (isDuplicate) {
                                                                            Swal.fire({
                                                                                icon: 'info',
                                                                                title: 'Duplicate Entry',
                                                                                text: 'This college code has already been selected. Please select another College',
                                                                            }).then(() => {
                                                                                soclandalloFormik.setFieldValue(`socOtherCollCode[${index}].otherCollCode`, '');
                                                                            });
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value="">--select--</option>
                                                                    {collegeList &&
                                                                        collegeList?.map((CLG, i) => (
                                                                            <option key={i} value={CLG?.coll_code}>
                                                                                {CLG?.inst_name}
                                                                            </option>
                                                                        ))}
                                                                </Field>
                                                                <ErrorMessage name={`socOtherCollCode[${index}].otherCollCode`} component="div" className="text-error" />
                                                            </td>

                                                            <td align="right" colSpan={7} className="text-center">
                                                                {index === 0 ? (
                                                                    <button
                                                                        type="button"
                                                                        className="button-titile btn btn-sm btn-success me-2"
                                                                        onClick={() => push({ otherCollCode: '' })}
                                                                    >
                                                                        <VscDiffAdded />
                                                                    </button>
                                                                ) : ""}
                                                                {/* soclandalloFormik?.values?.socOtherCollCode?.length > 1 &&  */}
                                                                {index >= 1 ? (
                                                                    <button
                                                                        type="button"
                                                                        className="button-titile btn btn-sm btn-danger"
                                                                        onClick={() => remove(index)}
                                                                    >
                                                                        <VscDiffRemoved />
                                                                    </button>
                                                                ) : ""}

                                                            </td>
                                                        </tr>
                                                    ))
                                                    )}
                                                </FieldArray>
                                            </tbody>
                                        </table>
                                    </div>
                                </>) : (<></>)}
                                {soclandalloFormik?.values?.buildOwnLease === "false" ? (<>
                                    <div className="inner-herbpage-service-title-sub"  >
                                        <h1 className=""> Building Lease Details  </h1>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>  S.No	</th>
                                                    <th> Document No./Year Ex:0001/2004	</th>
                                                    <th> Date of Registration(dd/mm/yyyy)</th>
                                                    <th> Survey No.</th>
                                                    <th>District</th>
                                                    <th>SRO Division	</th>
                                                    <th> Registrar Office</th>
                                                    <th>Name of the Lease</th>
                                                    <th>Leased From <br />(dd/mm/yyyy)</th>
                                                    <th>Leased Upto<br />(dd/mm/yyyy)</th>
                                                    <th>Address of the Property Leased</th>
                                                    <th>Total Area(in Sq.Mts)</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <FieldArray name="socBuildingLease">
                                                    {(QualificationValues) => {
                                                        return QualificationValues.form.values.socBuildingLease.map((qual, index) => {
                                                            return (
                                                                <>
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <center>{index + 1}</center>
                                                                        </td>
                                                                        <td>
                                                                            <Field
                                                                                type="text"
                                                                                className="form-control form-control-md"
                                                                                name={`socBuildingLease[${index}].documentNumber`}
                                                                                style={{ width: '8rem' }}
                                                                                maxLength="9" onChange={(e) =>
                                                                                    formatRegNoInput(e, `socBuildingLease[${index}].documentNumber`)
                                                                                }>
                                                                            </Field>
                                                                            <ErrorMessage name={`socBuildingLease[${index}].documentNumber`} component="div" className="text-error" />
                                                                        </td>
                                                                        <td>
                                                                            <Field type="date" className="form-control mt-1" name={`socBuildingLease[${index}].dateOfRegistration`}
                                                                                min="1970-01-01" max={new Date().toISOString().split("T")[0]}
                                                                                onKeyDown={(e) => { e.preventDefault() }} />
                                                                            <ErrorMessage name={`socBuildingLease[${index}].dateOfRegistration`} component="div" className="text-error" /></td>
                                                                        <td>
                                                                            <Field type="text" className="form-control mt-1" name={`socBuildingLease[${index}].surveyNumber`} maxLength="15" />
                                                                            <ErrorMessage name={`socBuildingLease[${index}].surveyNumber`} component="div" className="text-error" /></td>
                                                                        <td>
                                                                            <Field as="select" className="form-control mt-1" name={`socBuildingLease[${index}].distId`}
                                                                                onChange={(e) => { GetSroDist(e?.target?.value, index) }}>
                                                                                <option value=''>--select--</option>
                                                                                {reducerDistricts !== undefined && reducerDistricts !== null && reducerDistricts !== ''
                                                                                    && reducerDistricts?.map((ds, i) => {
                                                                                        return (<option key={i} value={ds?.dist_code}> {ds?.dist_name} </option>);
                                                                                    })}
                                                                            </Field>
                                                                            <ErrorMessage name={`socBuildingLease[${index}].distId`} component="div" className="text-error" /></td>
                                                                        <td>   <Field as="select" className="form-control mt-1" name={`socBuildingLease[${index}].sroDiv`}
                                                                            onChange={(e) => {
                                                                                const distCode = soclandalloFormik?.values?.socBuildingLease[index]?.distId;
                                                                                const sroDivCode = e?.target?.value;
                                                                                GetRegOfffices(distCode, sroDivCode, index);
                                                                            }}>
                                                                            <option value=''>--select--</option>
                                                                            {SroDist?.[index] && SroDist[index].map((ds, i) => (
                                                                                <option key={i} value={ds?.sro_div_code}>{ds?.sro_div_name}  </option>))}
                                                                        </Field>
                                                                            <ErrorMessage name={`socBuildingLease[${index}].sroDiv`} component="div" className="text-error" /></td>
                                                                        <td>
                                                                            <Field as="select" className="form-control mt-1" name={`socBuildingLease[${index}].sroOffice`}>
                                                                                <option value=''>--select--</option>
                                                                                {RegOfffices?.[index] && RegOfffices[index].map((ds, i) => (
                                                                                    <option key={i} value={ds?.sro_id}>
                                                                                        {ds?.sro_location}
                                                                                    </option>))}
                                                                            </Field>
                                                                            <ErrorMessage name={`socBuildingLease[${index}].sroOffice`} component="div" className="text-error" /></td>
                                                                        <td>
                                                                            <Field type="text" className="form-control mt-1" name={`socBuildingLease[${index}].nameOfLeasee`} maxLength={100} />
                                                                            <ErrorMessage name={`socBuildingLease[${index}].nameOfLeasee`} component="div" className="text-error" /></td>

                                                                        <td>
                                                                            <Field
                                                                                type="date" onKeyDown={(e) => { e.preventDefault() }}
                                                                                className="form-control mt-1"
                                                                                name={`socBuildingLease[${index}].leasedFrom`}
                                                                                min={soclandalloFormik?.values.socBuildingLease[index].dateOfRegistration}
                                                                                max={new Date().toISOString().split("T")[0]}
                                                                                onClick={() =>
                                                                                    soclandalloFormik?.setFieldValue(`socBuildingLease[${index}].leasedFrom`, '')
                                                                                }
                                                                            />
                                                                            <ErrorMessage
                                                                                name={`socBuildingLease[${index}].leasedFrom`}
                                                                                component="div"
                                                                                className="text-error"
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Field
                                                                                type="date" onKeyDown={(e) => { e.preventDefault() }}
                                                                                className="form-control mt-1" name={`socBuildingLease[${index}].leasedUpto`}
                                                                                // min={soclandalloFormik?.values?.socBuildingLease?.[index]?.leasedFrom || ""}  // Ensure leasedFrom is valid
                                                                                min={new Date().toISOString().split("T")[0]}
                                                                            />
                                                                            <ErrorMessage
                                                                                name={`socBuildingLease[${index}].leasedUpto`}
                                                                                component="div"
                                                                                className="text-error"
                                                                            />
                                                                        </td>

                                                                        <td>
                                                                            <Field type="text" className="form-control mt-1" name={`socBuildingLease[${index}].address`} maxLength="100" />
                                                                            <ErrorMessage name={`socBuildingLease[${index}].address`} component="div" className="text-error" /></td>
                                                                        <td>
                                                                            <Field type="text" className="form-control mt-1" name={`socBuildingLease[${index}].extentOfLand`} onKeyPress={(e) => { AllowFloats(e); }} onPaste={(e) => handlePaste(e)} />
                                                                            <ErrorMessage name={`socBuildingLease[${index}].extentOfLand`} component="div" className="text-error" /></td>

                                                                        <td align="center">
                                                                            {index === 0 ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="button-titile btn btn-sm btn-success"
                                                                                    onClick={() => {
                                                                                        QualificationValues.push({
                                                                                            documentNumber: "",
                                                                                            dateOfRegistration: "",
                                                                                            surveyNumber: "",
                                                                                            distId: "",
                                                                                            sroDiv: "",
                                                                                            sroOffice: "",
                                                                                            nameOfLeasee: "",
                                                                                            leasedFrom: "",
                                                                                            leasedUpto: "",
                                                                                            address: "",
                                                                                            extentOfLand: ""
                                                                                        });
                                                                                    }}>
                                                                                    <VscDiffAdded></VscDiffAdded>{" "}
                                                                                </button>
                                                                            ) : ""}
                                                                            {/* && index === soclandalloFormik?.values?.socBuildingLease?.length - 1 */}
                                                                            {index >= 1 ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="button-titile btn btn-sm btn-danger"
                                                                                    onClick={() => QualificationValues.remove(index)}>
                                                                                    <BiTrash></BiTrash>
                                                                                </button>
                                                                            ) : ""}
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            );
                                                        });
                                                    }}
                                                </FieldArray>
                                            </tbody>
                                        </table>
                                    </div>
                                </>) : (<></>)}
                                {soclandalloFormik?.values?.buildOwnLease === "false" ? (<>
                                    {LeaseDetails?.length > 0 ? (<>
                                        <div className="inner-herbpage-service-title-sub">
                                            <h1 className=""> Building Lease Details Report</h1></div>
                                        <div className="table-responsive">
                                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                                <thead>
                                                    <tr>
                                                        <th>SNO</th>
                                                        <th>Document No./Year</th>
                                                        <th>Date of Registration(dd/mm/yyyy)</th>
                                                        <th>Survey No</th>
                                                        <th>District</th>
                                                        <th>SRO Division	</th>
                                                        <th>Registrar Office</th>
                                                        <th>Name of the Lease</th>
                                                        <th>Leased From(dd/mm/yyyy)</th>
                                                        <th>Leased Upto(dd/mm/yyyy)</th>
                                                        <th>Address of the Property Leased</th>
                                                        <th>Leased	Extent of Land (in Acres)</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {LeaseDetails !== undefined && LeaseDetails !== null && LeaseDetails !== '' && LeaseDetails?.map((data, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td>{data?.document_number ?? "-"}</td>
                                                            <td>{data?.date_of_registration ?? '-'}</td>
                                                            <td className='tetx-left'>{data?.survey_number ?? '-'}</td>
                                                            <td className='text-left'>{data?.dist_name ?? '-'}</td>
                                                            <td className='text-left'>{data?.sro_div_name ?? '-'}</td>
                                                            <td className='text-left'>{data?.sro_location ?? '-'}</td>
                                                            <td className='text-left'>{data?.name_of_leasee ?? '-'}</td>
                                                            <td>{data?.leased_from ?? '-'}</td>
                                                            <td>{data?.leased_upto ?? '-'}</td>
                                                            <td className='text-left'>{data?.address ?? '-'}</td>
                                                            <td>{data?.extent_of_land ?? '-'}</td>
                                                            <td colSpan={2}>
                                                                <button type='button' className='btn btn-danger btn-sm mt-2 float-end' onClick={() => { DeleteLeaseDetails(data?.unq_id) }}><FaRegTrashAlt /></button></td></tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>) : (<></>)}
                                </>) : (<></>)}

                                <div className="inner-herbpage-service-title-sub"  >
                                    <h1 className="">
                                        {soclandalloFormik?.values?.buildOwnLease === "true" ? (<> Registered Land details </>) : (<>Proposed Land Details ( Details of the Land that
                                            College will be moving after the Permissible Period)</>)}
                                    </h1>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th>  S.No	</th>
                                                <th> Document No./Year Ex:0001/2004	</th>
                                                <th> Date of Registration(dd/mm/yyyy)</th>
                                                <th> Survey No.</th>
                                                <th>Extent of Land (in Acres)</th>
                                                <th>District</th>
                                                <th>SRO Division	</th>
                                                <th> Registrar Office</th>
                                                <th> Upload Land Registration Document</th>
                                                <th>Upload Land EC	</th>
                                                <th> Is Land Mortgaged</th>
                                                <th> Mortgage  registered Document No</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <FieldArray name="socLand">
                                                {(QualificationValues) => {
                                                    return QualificationValues.form.values.socLand.map((qual, index) => {
                                                        return (<>
                                                            <tr key={index}>
                                                                <td><center>{index + 1}</center></td>
                                                                <td>
                                                                    <Field type="text" className="form-control form-control-md" name={`socLand[${index}].regNo`} style={{ width: '8rem' }} maxLength="9"
                                                                        onChange={(e) =>
                                                                            formatRegNoInput(e, `socLand[${index}].regNo`)
                                                                        } />
                                                                    <ErrorMessage name={`socLand[${index}].regNo`} component="div" className="text-error" /></td>
                                                                <td> <Field type="date" className="form-control mt-1" name={`socLand[${index}].regDate`} onKeyDown={(e) => { e.preventDefault() }} max={new Date().toISOString().split("T")[0]}
                                                                />
                                                                    <ErrorMessage name={`socLand[${index}].regDate`} component="div" className="text-error" /></td>
                                                                <td> <Field type="text" className="form-control mt-1" name={`socLand[${index}].surveyNo`} maxLength="15" />
                                                                    <ErrorMessage name={`socLand[${index}].surveyNo`} component="div" className="text-error" /></td>
                                                                <td>  <Field type="text" className="form-control mt-1" name={`socLand[${index}].areaAcres`} onKeyPress={(e) => { AllowFloats(e); }} onPaste={(e) => handlePaste(e)} />
                                                                    <ErrorMessage name={`socLand[${index}].areaAcres`} component="div" className="text-error" /></td>
                                                                <td>   <Field as="select" className="form-control mt-1" name={`socLand[${index}].district`}
                                                                    onChange={(e) => { GetProSroDist(e?.target?.value, index) }}>
                                                                    <option value=''>--select--</option>
                                                                    {reducerDistricts !== undefined && reducerDistricts !== null && reducerDistricts !== '' && reducerDistricts?.map((ds, i) => {
                                                                        return (<option key={i} value={ds?.dist_code}> {ds?.dist_name} </option>);
                                                                    })}</Field>
                                                                    <ErrorMessage name={`socLand[${index}].district`} component="div" className="text-error" /></td>
                                                                <td>  <Field as="select" className="form-control mt-1" name={`socLand[${index}].sroDiv`}
                                                                    onChange={(e) => {
                                                                        const distCode = soclandalloFormik?.values.socLand[index]?.district;
                                                                        const sroDivCode = e?.target?.value;
                                                                        GetProRegOfffices(distCode, sroDivCode, index);
                                                                    }}>
                                                                    <option value=''>--select--</option>
                                                                    {prosroDist?.[index] && prosroDist[index].map((ds, i) => (
                                                                        <option key={i} value={ds?.sro_div_code}>{ds?.sro_div_name}  </option>))} </Field>
                                                                    <ErrorMessage name={`socLand[${index}].sroDiv`} component="div" className="text-error" /></td>

                                                                <td>
                                                                    <Field as="select" className="form-control mt-1" name={`socLand[${index}].sroOffice`}>
                                                                        <option value=''>--select--</option>
                                                                        {proRegOfffices?.[index] && proRegOfffices[index].map((ds, i) => (
                                                                            <option key={i} value={ds?.sro_id}>
                                                                                {ds?.sro_location}
                                                                            </option>))}  </Field>
                                                                    <ErrorMessage name={`socLand[${index}].sroOffice`} component="div" className="text-error" /></td>
                                                                <td>


                                                                    <input
                                                                        type="file" accept="application/pdf"
                                                                        name={`socLand[${index}].uploadRegDoc`} className="form-control mt-2"
                                                                        style={{ width: '9rem' }}
                                                                        onChange={(e) => {
                                                                            let filename = `uploadRegDoc`;
                                                                            let path = "/Uploads/AffiliationLandDocuments/2023/"
                                                                            ImagePdfBucket(e, soclandalloFormik, path, `socLand[${index}].uploadRegDoc`, filename, "pdf")
                                                                        }}
                                                                    />
                                                                    {soclandalloFormik?.values?.socLand[index].uploadRegDoc && <button type='button' className='btn btn-primary'
                                                                        onClick={() => { viewImage(soclandalloFormik?.values?.socLand[index].uploadRegDoc) }}><BsEyeFill size={17} /></button>}
                                                                    <ErrorMessage name={`socLand[${index}].uploadRegDoc`} component="div" className="text-error" />
                                                                </td>


                                                                <td>

                                                                    <input
                                                                        type="file" accept="application/pdf"
                                                                        name={`socLand[${index}].landEcDoc`} className="form-control mt-2"
                                                                        style={{ width: '9rem' }}
                                                                        onChange={(e) => {
                                                                            let filename = `landEcDoc`;
                                                                            let path = "/Uploads/AffiliationLandEc/2023/"
                                                                            ImagePdfBucket(e, soclandalloFormik, path, `socLand[${index}].landEcDoc`, filename, "pdf")
                                                                        }}
                                                                    />
                                                                    {soclandalloFormik?.values?.socLand[index].landEcDoc && <button type='button' className='text-primary'
                                                                        onClick={() => { viewImage(soclandalloFormik?.values?.socLand[index].landEcDoc) }}><BsEyeFill size={17} /></button>}
                                                                    <ErrorMessage name={`socLand[${index}].landEcDoc`} component="div" className="text-error" />
                                                                </td>
                                                                <td>
                                                                    <Field as="select" className="form-control mt-1" name={`socLand[${index}].isLandMortgaged`}>
                                                                        <option value=''>--select--</option>
                                                                        <option value="true">Yes</option>
                                                                        <option value="false">No</option>
                                                                    </Field>
                                                                    <ErrorMessage name={`socLand[${index}].isLandMortgaged`} component="div" className="text-error" /></td>
                                                                <td>
                                                                    {soclandalloFormik?.values?.socLand?.[index]?.isLandMortgaged === "true" && (<>

                                                                        <Field type="text" className="form-control mt-1" name={`socLand[${index}].mortgageRegisteredDocNo`} maxLength={10} />
                                                                        <ErrorMessage name={`socLand[${index}].mortgageRegisteredDocNo`} component="div" className="text-error" />
                                                                    </>)}
                                                                </td>
                                                                <td align="center">
                                                                    {index === 0 ? (
                                                                        <button
                                                                            type="button"
                                                                            className="button-titile btn btn-sm btn-success"
                                                                            onClick={() => {
                                                                                QualificationValues.push({
                                                                                    regNo: "",
                                                                                    regDate: "",
                                                                                    surveyNo: "",
                                                                                    areaAcres: "",
                                                                                    district: "",
                                                                                    sroDiv: "",
                                                                                    sroOffice: "",
                                                                                    uploadRegDoc: "",
                                                                                    landEcDoc: "",
                                                                                    isLandMortgaged: "",
                                                                                    mortgageRegisteredDocNo: "",
                                                                                    village: 0,
                                                                                    mandal: 0,
                                                                                });
                                                                            }}
                                                                        >
                                                                            <VscDiffAdded></VscDiffAdded>
                                                                        </button>
                                                                    ) : ""}
                                                                    {index >= 1 ? (
                                                                        <button
                                                                            type="button"
                                                                            className="button-titile btn btn-sm btn-danger"
                                                                            onClick={() => QualificationValues.remove(index)}
                                                                        >
                                                                            <BiTrash></BiTrash>
                                                                        </button>
                                                                    ) : ""}
                                                                </td>
                                                            </tr >
                                                        </>
                                                        );
                                                    });
                                                }}
                                            </FieldArray>
                                        </tbody>
                                    </table>
                                </div>
                                {OwnDetails?.length > 0 ? (<>
                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className=""> Land Details Report</h1></div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>SNO</th>
                                                    <th>Document No./Year</th>
                                                    <th>Date of Registration(dd/mm/yyyy)</th>
                                                    <th>Survey No</th>
                                                    <th>Extent of Land (in Acres)</th>
                                                    <th>District</th>
                                                    <th>SRO Division	</th>
                                                    <th>Registrar Office</th>
                                                    <th>Upload Land Registration Document</th>
                                                    <th>Upload Land EC</th>
                                                    <th>Is Land Mortgaged</th>
                                                    <th>Mortgage registered Document No</th>
                                                    <th colSpan={2}>Delete</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {OwnDetails !== undefined && OwnDetails !== null && OwnDetails !== '' && OwnDetails?.map((data, i) => (
                                                    <tr key={i}>
                                                        <td>{i + 1}</td>
                                                        <td>{data?.reg_no}</td>
                                                        <td>{data?.reg_date}</td>
                                                        <td>{data?.survey_no}</td>
                                                        <td>{data?.area_acres}</td>
                                                        <td>{data?.dist_name}</td>
                                                        <td>{data?.sro_div_name}</td>
                                                        <td>{data?.sro_location}</td>
                                                        <td className='cen'>
                                                            {data?.upload_reg_doc === '' || data?.upload_reg_doc === undefined || data?.upload_reg_doc === null ? (<strong>-</strong>) : (<>

                                                                <button type='button' className='btn btn-primary' onClick={() => { viewImage(data?.upload_reg_doc) }}><BsEyeFill size={17} /></button>
                                                            </>)}</td>
                                                        <td className='cen'>
                                                            {data?.land_ec_doc === '' || data?.land_ec_doc === undefined || data?.land_ec_doc === null ? (<strong>-</strong>) : (<>

                                                                <button type='button' className='btn btn-primary' onClick={() => { viewImage(data?.land_ec_doc) }}><BsEyeFill size={17} /></button>
                                                            </>)}</td>

                                                        <td>{data?.mortgaged}</td>

                                                        {/* <td>{data?.mortgage_registered_doc_no ?? "-"}</td> */}
                                                        <td>{data?.mortgage_registered_doc_no?.trim() ? data.mortgage_registered_doc_no : "-"}</td>

                                                        <td colSpan={2}>
                                                            <button type='button' className='btn btn-danger btn-sm mt-2 float-end' onClick={() => { DeleleSocLandDetails(data?.unq_id) }}><FaRegTrashAlt /></button>
                                                        </td>
                                                    </tr>))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>) : (<></>)}
                                {soclandalloFormik?.values?.buildOwnLease === "false" ? (<>
                                    <div className="inner-herbpage-service-title-sub "  >
                                        <h1 className="">Location of the Land in which College will be shifted after the completion of permitted
                                            period of running in Leased Accommodation </h1>
                                    </div>
                                    <bie.Row className="px-2 pt-3 m-0">
                                        <bie.Row>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>Plot No:</label>
                                                <Field type='text' name="platNo" className='form-control mb-2' onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} maxLength="10" />
                                                <ErrorMessage name="platNo" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>Survey No:	</label>
                                                <Field type='text' name="surveyNo" className='form-control mb-2' onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} maxLength="15" />
                                                <ErrorMessage name="surveyNo" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={6} xxl={6} className='mb-2'>
                                                <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>Distance from the present location of the college to the proposed shifting location (in KM) :</label>
                                                <Field type='text' name="distance" className='form-control mb-2' onKeyPress={(e) => { AllowFloats(e); }} onPaste={(e) => handlePaste(e)} />
                                                <ErrorMessage name="distance" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>District Name:</label>
                                                <Field as='select' name="distCode" className='form-control mb-2'
                                                    onChange={(e) => { getMandals(e?.target?.value, dispatch); clearMandalsFunc(); clearVillagesFunc() }}>
                                                    <option value="">--Select--</option>
                                                    {reducerDistricts !== undefined && reducerDistricts !== null && reducerDistricts !== '' && reducerDistricts?.map((ds, i) => {
                                                        return (<option key={i} value={ds?.dist_code}> {ds?.dist_name} </option>);
                                                    })}
                                                </Field>
                                                <ErrorMessage name="distCode" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>Mandal Name:</label>
                                                <Field as='select' name="mandalCode" className='form-control mb-2'
                                                    onChange={(e) => { getVillages(soclandalloFormik?.values?.distCode, e?.target?.value, dispatch); clearVillagesFunc() }}>
                                                    <option value="">--select--</option>
                                                    {reducermandal !== "No data found" && reducermandal !== undefined && reducermandal !== null && reducermandal !== '' &&
                                                        reducermandal?.map((mandaldata, i) => { return (<option key={i} value={mandaldata?.mandal_code}> {mandaldata?.mandal_name} </option>) })}
                                                </Field>
                                                <ErrorMessage name="mandalCode" component="div" className="text-error" />
                                            </bie.Col>

                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>Village Name:</label>
                                                <Field as='select' name="villageCode" className='form-control mb-2'>
                                                    <option value="">--Select--</option>
                                                    {reducervillage !== undefined && reducervillage !== null && reducervillage !== '' && reducervillage?.map((e, i) => {
                                                        return (<option key={i} value={e?.village_code}> {e?.village_name} </option>);
                                                    })}
                                                </Field >
                                                <ErrorMessage name="villageCode" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>Total Extent of Land(In Acres):</label>
                                                <Field type='text' name="totalLand" className='form-control mb-2' onKeyPress={(e) => { AllowFloats(e); }} onPaste={(e) => handlePaste(e)} />
                                                <ErrorMessage name="totalLand" component="div" className="text-error" />
                                            </bie.Col>
                                        </bie.Row>
                                    </bie.Row>
                                </>) : (<></>)
                                }
                                {soclandalloFormik?.values?.buildOwnLease === "true" ? (<>
                                    <div className="inner-herbpage-service-title-sub "><h1 className="">Land Details</h1></div>
                                    <bie.Row className="px-2 pt-3 m-0">
                                        <bie.Row>

                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Extent of the Land in which the college is being run (In Acres) :</label>
                                                <Field type='text' name="landCollRun" className='form-control mb-2' onKeyPress={(e) => { AllowFloats(e) }} onPaste={(e) => handlePaste(e)} />
                                                <ErrorMessage name="landCollRun" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Extent of the Land Allocated by the Society to this college (In Acres) :</label>
                                                <Field type='text' name="landAlloc" className='form-control mb-2' onKeyPress={(e) => { AllowFloats(e) }} onPaste={(e) => handlePaste(e)} />
                                                <ErrorMessage name="landAlloc" component="div" className="text-error" /></bie.Col>

                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Type of the Land Registration :</label>
                                                <Field as='select' name="regType" className='form-control  down-marg'>
                                                    <option value="">--Select--</option>
                                                    <option value="1">Registered Gift deed </option>
                                                    <option value="2">Registered Sale Deed </option>
                                                    <option value="3">Government Lease</option>
                                                    <option value="4">Others</option>
                                                </Field>
                                                <ErrorMessage name="regType" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Land Type :</label>
                                                <Field as='select' name="landType" className='form-control down-marg2'>
                                                    <option value="">--Select--</option>
                                                    <option value="1">Contiguous</option>
                                                    <option value="2">Bits (or) Pieces</option>
                                                </Field>
                                                <ErrorMessage name="landType" component="div" className="text-error" />
                                            </bie.Col>
                                        </bie.Row>
                                    </bie.Row>

                                    <div className="inner-herbpage-service-title-sub"  >
                                        <h1 className="">Society-College Land Allotment Details</h1>
                                    </div>
                                    <bie.Row className="px-2 pt-3 m-0 ">
                                        <bie.Row>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Allotment Date :</label>
                                                <Field type='date' name="allocDate" className='form-control down-marg3' min="1970-01-01" max={new Date().toISOString().split('T')[0]}
                                                    onKeyDown={(e) => { e.preventDefault() }}

                                                    onClick={() => soclandalloFormik?.setFieldValue('allocUpto', '')} ></Field>
                                                <ErrorMessage name="allocDate" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Valid Upto Date :</label>
                                                <Field type='date' name="allocUpto" className='form-control down-marg3' min={soclandalloFormik?.values?.allocDate} onKeyDown={(e) => { e.preventDefault() }}
                                                />
                                                <ErrorMessage name="allocUpto" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Upload Copy of Resolution(.pdf only) :</label>
                                                <div className='d-flex align-items-center'>
                                                    <input
                                                        type="file" accept="application/pdf"
                                                        name="socUpload"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            let filename = `socUpload`;
                                                            let path = "/Uploads/AffiliationLandAllotmentDocuments/2023/"
                                                            ImagePdfBucket(e, soclandalloFormik, path, "socUpload", filename, "pdf")
                                                        }}
                                                    />

                                                    <ErrorMessage name="socUpload" component="div" className="text-error" />
                                                    {soclandalloFormik?.values?.socUpload && <button type='button' className='btn btn-primary'
                                                        onClick={() => { viewImage(soclandalloFormik?.values?.socUpload) }}><BsEyeFill size={17} className='ms-2' /></button>}
                                                </div>
                                            </bie.Col>
                                        </bie.Row>
                                    </bie.Row>
                                    <div className="inner-herbpage-service-title-sub"  >
                                        <h1 className=""> Khasra plan/Location Map Issued by the MRO</h1>
                                    </div>
                                    <bie.Row className="px-2 pt-3 mx-0  ">
                                        <bie.Row className="px-2 pt-3 mx-0  ">
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Issued By :	</label>
                                                <Field type='text' name="khasraIssuedBy" className='form-control mb-2' maxLength="15" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />
                                                <ErrorMessage name="khasraIssuedBy" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Issued Date  :</label>
                                                <Field type='date' name="khasraDate" className='form-control mb-2' min="1970-01-01" max={new Date().toISOString().split('T')[0]}
                                                    onKeyDown={(e) => { e.preventDefault() }}
                                                />
                                                <ErrorMessage name="khasraDate" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Khasra Plan Document No :</label>
                                                <Field type="text" className="form-control" name="khasraDocNo" maxLength="15" />
                                                <ErrorMessage name="khasraDocNo" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={3} className='mb-2'>
                                                <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Upload Certificate ( .pdf only) :</label>
                                                <div className='d-flex align-items-center'>
                                                    <input
                                                        type="file" accept="application/pdf"
                                                        name="khasraPlan"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            let filename = `khasraPlan`;
                                                            let path = "/Uploads/AffiliationKhasraDocuments/2023/"
                                                            ImagePdfBucket(e, soclandalloFormik, path, "khasraPlan", filename, "pdf")
                                                        }}
                                                    />

                                                    <ErrorMessage name="khasraPlan" component="div" className="text-error" />
                                                    {soclandalloFormik?.values?.khasraPlan && <button type='button' className='btn btn-primary'
                                                        onClick={() => { viewImage(soclandalloFormik?.values?.khasraPlan) }}><BsEyeFill size={17} className='ms-2' /></button>}
                                                </div>
                                            </bie.Col>
                                        </bie.Row>
                                    </bie.Row>

                                    <bie.Row className='pt-4'>
                                        <bie.Col xs={12} sm={12} md={12} lg={12} xl={6} xxl={6} className='mb-2'>
                                            <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Land Conversion Details are available</label> &emsp;
                                            <Field type="radio" name="landConvData" value="true" />&nbsp;Yes&emsp;
                                            <Field type="radio" name="landConvData" value="false" onChange={(e) => {
                                                if (e?.target?.value === "false" || OwnDetails?.length === 0) {
                                                    ClearLandConversion();
                                                }
                                            }} />&nbsp; No
                                            <ErrorMessage name="landConvData" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={12} xl={6} xxl={6} className='mb-2'>
                                            <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Land Usage Details are available</label>&emsp;&emsp;&emsp;&emsp;&emsp;
                                            <Field type="radio" name="landUsagedata" value="true" />&nbsp;Yes&emsp;
                                            <Field type="radio" name="landUsagedata" value="false" onChange={(e) => {
                                                if (e?.target?.value === "false" || OwnDetails?.length === 0) {
                                                    ClearLandUsage();
                                                }
                                            }} />&nbsp;No
                                            <ErrorMessage name="landUsagedata" component="div" className="text-error" />
                                        </bie.Col>
                                    </bie.Row>

                                    {/* </bie.Row> */}
                                    {soclandalloFormik?.values?.landConvData === "true" ? (<>

                                        <div className="inner-herbpage-service-title-sub"  >
                                            <h1 className="mb-0">Land Conversion Details </h1>
                                        </div>
                                        <bie.Row className="px-2 pt-3 m-0 ">
                                            <bie.Row>
                                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                                    <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Issued By :	</label>
                                                    <Field type='text' name="landIssued" className='form-control mb-2' maxLength="100" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }}></Field>
                                                    <ErrorMessage name="landIssued" component="div" className="text-error" />
                                                </bie.Col>
                                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                                    <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Issued Date  :</label>
                                                    <Field type='date' name="landDate" className='form-control mb-2' min="1970-01-01" max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                                    <ErrorMessage name="landDate" component="div" className="text-error" />
                                                </bie.Col>
                                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                                    <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Purpose :</label>
                                                    <Field type='text' name="landPurpose" className='form-control mb-2' maxLength="300" />
                                                    <ErrorMessage name="landPurpose" component="div" className="text-error" />
                                                </bie.Col>
                                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={5} xxl={3} className='mb-2 '>
                                                    <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Upload Conversion Certificate(.pdf only):</label>
                                                    <div className='d-flex align-items-center'>
                                                        <input
                                                            type="file" accept="application/pdf"
                                                            name="landFile"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                let filename = `landFile`;
                                                                let path = "/Uploads/AffiliationConversionDocuments/2023/"
                                                                ImagePdfBucket(e, soclandalloFormik, path, "landFile", filename, "pdf")
                                                            }}
                                                        />

                                                        <ErrorMessage name="landFile" component="div" className="text-error" />
                                                        {soclandalloFormik?.values?.landFile && <button type='button' className='btn btn-primary'
                                                            onClick={() => { viewImage(soclandalloFormik?.values?.landFile) }}><BsEyeFill size={17} className='ms-2' /></button>}
                                                    </div>
                                                </bie.Col>
                                            </bie.Row>
                                        </bie.Row>
                                    </>) : (<></>)}
                                    {soclandalloFormik?.values?.landUsagedata === "true" ? (<>
                                        <div className="inner-herbpage-service-title-sub"  >
                                            <h1 className="">Land Usage Details </h1>
                                        </div>
                                        <bie.Row className="px-2 pt-3 m-0 ">
                                            <bie.Row>
                                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                                    <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Issued By :</label>
                                                    <Field type='text' name="landUsage" className='form-control mb-2' maxLength="100" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }}></Field>
                                                    <ErrorMessage name="landUsage" component="div" className="text-error" />
                                                </bie.Col>
                                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                                    <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Issued Date  :</label>
                                                    <Field type='date' name="landUsageDate" className='form-control mb-2' min="1970-01-01" max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }}
                                                    />
                                                    <ErrorMessage name="landUsageDate" component="div" className="text-error" />
                                                </bie.Col>
                                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                                    <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Purpose :</label>
                                                    <Field type='text' name="landUsagePurpose" className='form-control mb-2' maxLength="300" />
                                                    <ErrorMessage name="landUsagePurpose" component="div" className="text-error" />
                                                </bie.Col>
                                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={5} xxl={3} className='mb-2'>
                                                    <label classname='mb-1' >  <b style={{ color: 'red' }}>* </b>Upload Land Usage Certificate(.pdf only):</label>
                                                    <div className='d-flex align-items-center'>
                                                        <input
                                                            type="file" accept="application/pdf"
                                                            name="landUsageCerti"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                let filename = `landUsageCerti`;
                                                                let path = "/Uploads/AffiliationConversionDocuments/2023/"
                                                                ImagePdfBucket(e, soclandalloFormik, path, "landUsageCerti", filename, "pdf")
                                                            }}
                                                        />

                                                        <ErrorMessage name="landUsageCerti" component="div" className="text-error" />
                                                        {soclandalloFormik?.values?.landUsageCerti && <button type='button' className='btn btn-primary'
                                                            onClick={() => { viewImage(soclandalloFormik?.values?.landUsageCerti) }}><BsEyeFill size={17} className='ms-2' /></button>}
                                                    </div>
                                                </bie.Col>
                                            </bie.Row>
                                        </bie.Row>
                                    </>) : (<></>)}
                                </>) : (<></>)
                                }
                            </>) : (<></>)}



                            <button type='submit' className='btn btn-success btn-sm mt-2 float-end'>Submit</button>
                        </Form></FormikProvider></bie.Container></bie.Container >
        </>
    )

}